var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeftCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 13H8.75L12 16.25L11.336 17L6.836 12.5L11.336 8L12 8.75L8.75 12H17V13ZM2 12.5C2 11.2524 2.24572 10.0171 2.72314 8.86451C3.20056 7.71191 3.90033 6.66464 4.78249 5.78249C5.66464 4.90033 6.71191 4.20056 7.86451 3.72314C9.0171 3.24572 10.2524 3 11.5 3C12.7476 3 13.9829 3.24572 15.1355 3.72314C16.2881 4.20056 17.3354 4.90033 18.2175 5.78249C19.0997 6.66464 19.7994 7.71191 20.2769 8.86451C20.7543 10.0171 21 11.2524 21 12.5C21 15.0196 19.9991 17.4359 18.2175 19.2175C16.4359 20.9991 14.0196 22 11.5 22C8.98044 22 6.56408 20.9991 4.78249 19.2175C3.00089 17.4359 2 15.0196 2 12.5ZM3 12.5C3 14.7543 3.89553 16.9163 5.48959 18.5104C7.08365 20.1045 9.24566 21 11.5 21C13.7543 21 15.9163 20.1045 17.5104 18.5104C19.1045 16.9163 20 14.7543 20 12.5C20 10.2457 19.1045 8.08365 17.5104 6.48959C15.9163 4.89553 13.7543 4 11.5 4C9.24566 4 7.08365 4.89553 5.48959 6.48959C3.89553 8.08365 3 10.2457 3 12.5Z",
    fill: "#646397"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftCircle);
export default __webpack_public_path__ + "static/media/arrow-left-circle.8316ee940c23fcac8ec71ec300222e6c.svg";
export { ForwardRef as ReactComponent };